import { render, staticRenderFns } from "./view-vendas.vue?vue&type=template&id=484b0efa"
import script from "./view-vendas.vue?vue&type=script&lang=js"
export * from "./view-vendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports